export const LEADERBOARD_ACTIONS = {
  FETCH_ENTRIES: 'LEADERBOARD/FETCH_ENTRIES',
  FETCH_ENTRIES_SUCCESS: 'LEADERBOARD/FETCH_ENTRIES_SUCCESS',
  FETCH_ENTRIES_ERROR: 'LEADERBOARD/FETCH_ENTRIES_ERROR',
  OPEN: 'LEADERBOARD/OPEN',
  CLOSE: 'LEADERBOARD/CLOSE',
};
